import React, { useEffect, useState, useRef } from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../config";
import Swal from "sweetalert2";
import { triggerNotification } from "../../component/message/Msg";
import TableViewer from "../../component/tableViewer/TableViewer";

const ViewAssignment = () => {
  const { id, ctype, cid } = useParams();
  const token = config.token;
  const navigate = useNavigate();
  const [assignmentFor, setAssignmentFor] = useState("course");
  const [loading, setLoading] = useState(false);
  const [assignments, setAssignments] = useState([]);
  const [courses, setCourses] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [courseSearchTerm, setCourseSearchTerm] = useState('');
  const [chapterSearchTerm, setChapterSearchTerm] = useState('');
  
  const [isCourseDropdownOpen, setIsCourseDropdownOpen] = useState(false);
  const [isChapterDropdownOpen, setIsChapterDropdownOpen] = useState(false);

  //----------------------------------- state management -----------------------------
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [selectedChapterId, setSelectedChapterId] = useState("");

  //  ------For TableViewer ------
  const assignmentsRef = useRef([]);
  assignmentsRef.current = assignments;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  const handleSelectedCourseIdChange = (courseId) => {
    setRowData([]);
    setSelectedCourseId(courseId);
    setCourseSearchTerm("");

    if (assignmentFor === "chapter") {
      // Fetch chapter list
      setSelectedChapterId("");
      fetch(`${config.host_url}pages/chaptersbycourse/${courseId}`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            setChapters(data.data);
          } else if (data.status === 401) {
            // Invalid token
            console.error("Invalid token");
          } else {
            // Handle other errors
            console.error("Internal server error");
          }
        })
        .catch((error) => {
          console.error("Error fetching chapter:", error);
        });
    } else {
      // Fetch chapter list
      fetch(`${config.host_url}pages/coursedetail/${courseId}`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            console.log(data.data.assignment);
            setAssignments(data.data.assignment);
            const assignmentsData = data.data.assignment.map((asg) => ({
              title: asg.title,
              idNumber: asg.caid,
            }));
            setRowData(assignmentsData);
            // setChapters(data.data);
          } else if (data.status === 401) {
            // Invalid token
            console.error("Invalid token");
          } else {
            // Handle other errors
            console.error("Internal server error");
          }
        })
        .catch((error) => {
          console.error("Error fetching chapter:", error);
        });
    }
  };

  const handleAssignmentForRadioChange = (e) => {
    setAssignmentFor(e.target.value);
    setChapters([]); // Clear chapters on changing assignment
    setSelectedChapterId('');
    setSelectedCourseId('');
  };

  const filteredCourses = courses.filter((course) =>
    course.course_name.toLowerCase().includes(courseSearchTerm.toLowerCase())
  );

  const filteredChapters = chapters.filter((chapter) =>
    chapter.name.toLowerCase().includes(chapterSearchTerm.toLowerCase())
  );
  
  const handleSelectedChapterIdChange = (e) => {
    setRowData([]);
    setSelectedChapterId(e.target.value);

    // Fetch chapter list
    fetch(`${config.host_url}chapter/${e.target.value}`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setAssignments(data.data.assignment);
          const assignmentsData = data.data.assignment.map((asg) => ({
            title: asg.title,
            idNumber: asg.caid,
          }));
          setRowData(assignmentsData);
          console.log(data.data.assignment);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching chapter:", error);
      });
  };
  const assignmentForRadioChange = (event) => {
    setRowData([]);
    setChapters([]);
    setSelectedChapterId("");
    setSelectedCourseId("");
    setAssignmentFor(event.target.id);
  };

  // ---------------------------------- fetch course ------------------------------------
  //fetch data
  useEffect(() => {
    // Fetch course list
    fetch(`${config.host_url}course`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setCourses(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching courses:", error);
      });
  }, [token]);

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    { headerName: "Assignment", field: "title", filter: true },
  ];
  //  ------For TableViewer ------

  return (
    <>
      <Breadcrumb txt="Manage Assignment" subpath={["View Assignments"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">View Assignments</h5>
            <div>
              {/* <Export onExport={handleExport} /> */}
              <button
                type="button"
                className="btn btn-primary ml-4"
                onClick={() => {
                  navigate("/addassignmentque");
                }}
              >
                Add Assignment
              </button>
            </div>
          </div>

          {loading ? (
            <Spinner />
          ) : (
            <div className="">
              {/* Assignment For: CouseId/ ChapterId */}
              <div className="col-md-12 px-8">
      <div className="mb-2">
        <label className="form-check-label select-none ml-1 mb-2">Assignment For</label>
        <div>
          <div className="form-check form-check-inline">
            <input
              name="form-check-group-image"
              className="form-check-input"
              type="radio"
              value="course"
              checked={assignmentFor === 'course'}
              id="course"
              onChange={handleAssignmentForRadioChange}
            />
            <label className="form-check-label select-none" htmlFor="course">
              Course
            </label>
          </div>

          <div className="form-check form-check-inline">
            <input
              name="form-check-group-image"
              className="form-check-input"
              type="radio"
              value="chapter"
              checked={assignmentFor === 'chapter'}
              id="chapter"
              onChange={handleAssignmentForRadioChange}
            />
            <label className="form-check-label select-none" htmlFor="chapter">
              Chapter
            </label>
          </div>
        </div>
      </div>

      {/* Course dropdown with search functionality */}
      <div className="form-floating form-floating-outline mb-4">
        <div
          className="form-control"
          onClick={() => {
                          setIsCourseDropdownOpen(!isCourseDropdownOpen);
                          setIsChapterDropdownOpen(false)
                        }}
          style={{ cursor: 'pointer',
                 textAlign: selectedCourseId ? "start" : "center"
                 }}
        >
          {selectedCourseId
            ? courses.find((course) => course.course_id === selectedCourseId)?.course_name
            : '--- Select Course ---'}
        </div>

        {isCourseDropdownOpen && (
          <div
            className="dropdown-menu show"
            style={{
              maxHeight: '200px',
              overflowY: 'auto',
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              zIndex: 1,
              width: '100%',
              backgroundColor: 'white',
              boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
              zIndex: 5,
            }}
          >
            {/* Search input inside the course dropdown */}
            <input
              type="text"
              className="form-control mb-2"
              placeholder="Search Course..."
              value={courseSearchTerm}
              onChange={(e) => setCourseSearchTerm(e.target.value)}
              style={{
                padding: '5px',
                margin: '8px 20px 8px 5px',
                width: '95%',
              }}
            />
            <ul className="list-unstyled p-0 m-0">
              {filteredCourses.length > 0 ? (
                filteredCourses.map((course) => (
                  <li
                    key={course.course_id}
                    className="dropdown-item"
                    onClick={() => {
                      handleSelectedCourseIdChange(course.course_id);
                      setIsCourseDropdownOpen(false); // Close dropdown after selection
                      
                    }}
                    style={{ cursor: 'pointer', padding: '5px' }}
                  >
                    {course.course_name}
                  </li>
                ))
              ) : (
                <li className="dropdown-item text-muted">No courses found</li>
              )}
            </ul>
          </div>
        )}

        <label htmlFor="coursedropdown">Courses</label>
      </div>

      {/* Chapter dropdown with search functionality (Only if assignmentFor === 'chapter') */}
      {assignmentFor === 'chapter' && (
        <div className="form-floating form-floating-outline mb-4">
          <div
            className="form-control"
            onClick={() => {
                          setIsChapterDropdownOpen(!isChapterDropdownOpen);
                          setIsCourseDropdownOpen(false)
                          }}
            style={{ cursor: 'pointer',
                     textAlign : selectedChapterId ? "start" : "center"
             }}
          >
            {selectedChapterId
              ? chapters.find((chapter) => chapter.chapterid === selectedChapterId)?.name
              : '--- Select Chapter ---'}
          </div>

          {isChapterDropdownOpen && (
            <div
              className="dropdown-menu show"
              style={{
                maxHeight: '200px',
                overflowY: 'auto',
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                zIndex: 1,
                width: '100%',
                backgroundColor: 'white',
                boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
                zIndex: 5,
              }}
            >
              {/* Search input inside the chapter dropdown */}
              <input
                type="text"
                className="form-control mb-2"
                placeholder="Search Chapter..."
                value={chapterSearchTerm}
                onChange={(e) => setChapterSearchTerm(e.target.value)}
                style={{
                  padding: '5px',
                  margin: '8px 20px 8px 5px',
                  width: '95%',
                }}
              />
              <ul className="list-unstyled p-0 m-0">
                {filteredChapters.length > 0 ? (
                  filteredChapters.map((chapter) => (
                    <li
                      key={chapter.chapterid}
                      className="dropdown-item"
                      onClick={() => {
                        setSelectedChapterId(chapter.chapterid);
                        setIsChapterDropdownOpen(false); // Close dropdown after selection
                      }}
                      style={{ cursor: 'pointer', padding: '5px' }}
                    >
                      {chapter.name}
                    </li>
                  ))
                ) : (
                  <li className="dropdown-item text-muted">No chapters found</li>
                )}
              </ul>
            </div>
          )}

          <label htmlFor="chapterdropdown">Chapters</label>
        </div>
      )}
    </div>
              <div className="justify-center  pb-3 row mx-4 select-none">
                {/* ------For TableViewer ------ */}
                <TableViewer
                  rowData={rowData}
                  colDefs={colDefs}
                  onView={(id) => {
                    navigate(
                      `/studentsubmissions/${btoa(encodeURIComponent(id))}`
                    );
                  }}
                />
                {/* ------For TableViewer ------ */}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewAssignment;
